"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const SideNavButton = (props) => {
    const { isSelected, icon, label, badgeContent } = props;
    return (react_1.default.createElement(__1.Box, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "88px", minHeight: 56 },
        react_1.default.createElement(__1.IconButton, { ...props, sx: {
                ...props.sx,
                width: '64px',
                height: '40px',
                padding: '8px',
                borderRadius: '100px',
                boxSizing: 'border-box',
                backgroundColor: isSelected ? 'rgba(36, 129, 143, 0.08)' : 'transparent',
                '&:hover': {
                    backgroundColor: 'rgba(36, 129, 143, 0.04)',
                    '& svg': {
                        color: 'text.primary',
                    },
                },
                '&.Mui-focusVisible': {
                    backgroundColor: 'rgba(36, 129, 143, 0.30)',
                    '& svg': {
                        color: 'primary.dark',
                    },
                },
                '& svg': {
                    color: isSelected ? 'primary.dark' : 'text.secondary',
                    height: '18px',
                    width: '18px',
                },
            } }, badgeContent ? (react_1.default.createElement(__1.Badge, { content: badgeContent, sx: { top: -3, right: -7 } }, icon)) : (icon)),
        react_1.default.createElement(__1.Typography, { variant: "caption", weight: "medium", textAlign: "center", color: "text.primary" }, label)));
};
exports.default = SideNavButton;
